import { cn } from '~utils/cn'

type DialogTitleProps = Readonly<{
  children: string
  className?: string
}>

const DialogTitle = ({ children, className }: DialogTitleProps) => {
  return <h1 className={cn('mb-4 text-gray-900 text-headline-3 lg:mb-6', className)}>{children}</h1>
}

export default DialogTitle
